// extracted by mini-css-extract-plugin
module.exports = {"root":"Welcome-m__root___3-z9N","title":"Welcome-m__title___ljkJY","content":"Welcome-m__content___3iJUd"};